import { Injectable, inject, signal } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import type { MaintenanceStatus } from '../models/maintenance.models';

const INACTIVE_STATUS: MaintenanceStatus = {
  active: false,
  scheduled: false,
  source: null,
  message: null,
  plannedStart: null,
  plannedEnd: null,
  secondsUntilStart: null,
};

@Injectable({ providedIn: 'root' })
export class MaintenanceStatusService {
  // Bewusst HttpBackend statt HttpClient: Der Service wird vom api.interceptor
  // injiziert (bei 503/maintenance_mode). Wuerde der Service selbst durch den
  // Interceptor-Chain laufen, ergaebe das einen DI-/Request-Zyklus, der die
  // Login- und sonstige Request-Pipeline blockieren kann.
  private readonly http = new HttpClient(inject(HttpBackend));

  private readonly _status = signal<MaintenanceStatus>(INACTIVE_STATUS);

  /** Reaktives Signal — aktuell bekannter Wartungsstatus. */
  readonly status = this._status.asReadonly();

  /**
   * Fragt den Backend-Status-Endpoint ab und aktualisiert das Signal.
   * Muss vom Caller abonniert werden (lazy Observable).
   */
  refresh(): Observable<MaintenanceStatus> {
    return this.http
      .get<MaintenanceStatus>(`${environment.apiUrl}/maintenance/status`, { withCredentials: true })
      .pipe(tap((s) => this._status.set(s)));
  }
}
